"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _iconCloseNotification = _interopRequireDefault(require("../../images/icon-close-notification.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var IconNotificationClose = function IconNotificationClose(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("img", {
    alt: "Close notification",
    className: (0, _classnames.default)('icon-notification-close', className),
    src: _iconCloseNotification.default,
    onClick: onClick
  });
};
var _default = IconNotificationClose;
exports.default = _default;